import { battery, eventualDoubleMac, lastData, lastSeen } from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { NAModule } from '~/models/modules/NAModule.model';

export class WeatherModule extends NAModule {
    eventual_dble_mac = false;
    rf_status?: number;
    manual_pairing?: string;
    // for weather, measures are considered outdated after 1.5 hours
    MAX_TIME_BEFORE_DATA_OUTDATED = 1.5 * 3600;

    isWired = false;

    get fieldEventualDoubleMac() {
        return eventualDoubleMac(this.eventual_dble_mac);
    }
    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
    get fieldRfStatus() {
        return rfStatus(this.getRfIcon(this.rf_status), this.rf_status);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
    get fieldLastData() {
        return lastData(this.last_data, this.outdatedLastData ? 'error--text' : '');
    }
    get column(): string {
        return 'left';
    }

    get outdatedLastData(): boolean {
        return this.last_data ? Date.now() / 1000 - this.last_data > this.MAX_TIME_BEFORE_DATA_OUTDATED : true;
    }

}
